(() => {
  'use strict';
  if (window.mpQuoteAssetsLoader) return;
  window.mpQuoteAssetsLoader = true;

  const requests = new Map();
  const pendingOpens = new WeakSet();

  function loadAsset(url, kind, host) {
    if (requests.has(url)) return requests.get(url);
    const request = new Promise((resolve, reject) => {
      const element = document.createElement(kind === 'style' ? 'link' : 'script');
      if (kind === 'style') {
        element.rel = 'stylesheet';
        element.href = url;
      } else {
        element.src = url;
      }
      element.onload = resolve;
      element.onerror = () => {
        element.remove();
        requests.delete(url);
        reject(new Error(`Could not load quote modal ${kind}`));
      };
      // Al <head>: un rerender de la secció (editor, variants) no pot endur-se el CSS ni el JS carregats.
      document.head.appendChild(element);
    });
    requests.set(url, request);
    return request;
  }

  async function prepare(host) {
    await loadAsset(host.dataset.quoteCss, 'style', host);
    await loadAsset(host.dataset.quoteJs, 'script', host);
    await customElements.whenDefined('quote-modal');
  }

  function onInteraction(event) {
    const button = event.target.closest?.('[data-quote-open]');
    const host = button?.closest('quote-modal[data-quote-css]');
    if (!host) return;
    if (event.type === 'click' && customElements.get('quote-modal')) return;

    if (event.type === 'click') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (pendingOpens.has(host)) return;
      pendingOpens.add(host);
      prepare(host).then(() => {
        if (host.isConnected) host.open();
      }).catch(console.error).finally(() => pendingOpens.delete(host));
    } else {
      prepare(host).catch(console.error);
    }
  }

  for (const event of ['pointerover', 'touchstart', 'focusin', 'click']) {
    document.addEventListener(event, onInteraction, { capture: true });
  }

  // Preserve Shopify's native contact-form success return, including auto-open.
  if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
    document.querySelectorAll('quote-modal[data-quote-css]').forEach((host) => {
      prepare(host).catch(console.error);
    });
  }
})();
